import {
  Calendar,
  Clock,
  Gauge,
  Sparkles,
  Table2,
} from "lucide-react";

const STORAGE_PREFIX = "pagetest.productLanesSeen:";

function getEmailFromToken(token) {
  if (!token) return null;
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
        .join(""),
    );
    return JSON.parse(jsonPayload).email?.toLowerCase() || null;
  } catch {
    return null;
  }
}

export function hasSeenProductLanes(email) {
  if (!email) return true;
  return localStorage.getItem(`${STORAGE_PREFIX}${email.toLowerCase()}`) === "1";
}

export function markProductLanesSeen(email) {
  if (!email) return;
  localStorage.setItem(`${STORAGE_PREFIX}${email.toLowerCase()}`, "1");
}

export function shouldShowProductLanes({ email, isAdmin, welcomeParam }) {
  if (isAdmin || !email) return false;
  if (welcomeParam === "1") return true;
  return !hasSeenProductLanes(email);
}

export function maybeRedirectToWelcome(navigate, token, pathname) {
  const email = getEmailFromToken(token);
  if (!email || hasSeenProductLanes(email)) return;
  if (pathname.startsWith("/test") || pathname.startsWith("/report")) return;
  navigate("/dashboard?welcome=1");
}

export function getFirstName(user) {
  const name = user?.name?.trim();
  if (!name) return null;
  return name.split(/\s+/)[0];
}

export const PRODUCT_LANES = [
  {
    id: "run-test",
    title: "Run a PageSpeed test",
    hint: "Desktop and mobile Lighthouse scores in one session",
    icon: Gauge,
    href: "/test",
  },
  {
    id: "history",
    title: "View my test history",
    hint: "Past runs, scores, and quick re-tests",
    icon: Clock,
    tab: "history",
  },
  {
    id: "mappings",
    title: "Export to Google Sheets",
    hint: "Save results and map URLs to your spreadsheets",
    icon: Table2,
    tab: "mappings",
  },
  {
    id: "scheduled",
    title: "Schedule weekly checks",
    hint: "Auto-test URLs and log scores on a cadence",
    icon: Calendar,
    tab: "scheduled",
  },
  {
    id: "ai",
    title: "AI-powered fixes",
    hint: "Stack-aware suggestions and model preferences",
    icon: Sparkles,
    tab: "ai",
  },
];
